import type { QueryFunctionContext } from '@tanstack/react-query';
import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

type QueryContext = QueryFunctionContext<[string, string | undefined]>;

export const queryFn = async ({ queryKey: [_, userId] }: QueryContext) => {
  if (typeof userId === 'undefined') {
    return Promise.reject(new Error('User ID must be provided'));
  }
  const { NarrativePermissions, UserVotedNarratives, errors } =
    await gqlClient.request(
      gql(`
        query NarrativePermission {
          NarrativePermissions {
            canAddAnnouncement
            canDeleteAnnouncement
            canUpdateAnnouncement
          }
          UserVotedNarratives {
            narrativeId
          }
        }
      `),
      {}
    );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return {
    narrativePermissions: NarrativePermissions,
    userVotedNarratives: UserVotedNarratives,
  };
};
